import React, { useState } from "react";
import logo from "../aapico.jpg";
// import triangle from "../triangle.png";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import axios from "axios";
import dayjs from "dayjs";
import { flatMap } from "lodash";

export async function ahp_excel_sheet(dataExport) {
  // console.log(dataExport);
  const formattedDate = dayjs(dataExport.date, "DD-MM-YYYY").format(
    "MMMM DD YYYY"
  );

  // if (dataExport) {
  //   for (let i = 0; i < dataExport.dataquestion.length; i++)
  //     console.log(dataExport.dataquestion[i]?.checkPoint);
  // }
  const workbook = new ExcelJS.Workbook({ useStyle: true });
  const worksheet = workbook.addWorksheet("sheet", {
    pageSetup: {
      paperSize: 9,
      orientation: "landscape",
      // scale: 60,
      scale: 75,
      horizontalCentered: true,
      margins: {
        // left: 0.4,
        // left: 0.21,
        left: 0.4,
        right: 0.0,
        top: 0.3,
        bottom: 0.0,
        header: 0.0,
        footer: 0.0,
      },
    },
  });
  let font = { name: "AngsanaUPC", size: 16 };

  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear() + 543;

  const imagePartBuffer = await axios.get(dataExport.imagePart, {
    responseType: "arraybuffer",
  });

  const image_part = workbook.addImage({
    buffer: imagePartBuffer.data,
    extension: "png",
  });

  worksheet.addImage(image_part, {
    tl: { col: 0.5, row: 4.2 },
    br: { col: 3, row: 16.5 },
  });

  const imageBuffer = await axios.get(logo, {
    responseType: "arraybuffer",
  });
  const image_logo = workbook.addImage({
    buffer: imageBuffer.data,
    extension: "png", 
  });
  worksheet.addImage(image_logo, {
    tl: { col: 0.2, row: 0.5 },
    br: { col: 1.0, row: 2.9 },
  });
  // //////////////////////////////////Header///////////////////////////////////////////
  worksheet.mergeCells("A1:O1");
  worksheet.mergeCells("P1:R1");
  worksheet.mergeCells("N3:R3");
  worksheet.mergeCells("Q2:R2");

  worksheet.getCell("A1").value = "Receiving Inspection Check Sheet";
  worksheet.getCell("Q2").value = `${dataExport.documentNumber} `;
  worksheet.getCell("Q2").style = {
    font: {
      name: "Times New Roman",
      size: "12",
      bold: true,
    },
  };

  worksheet.getCell("Q2").alignment = {
    vertical: "center",
    horizontal: "right",
  };
  worksheet.getCell("P1").value = `TF-12.1-1 September 25,2017 (Rev2)`;
  worksheet.getCell("P1").style = {
    font: {
      name: "Times New Roman",
      size: "10",
      bold: false,
    },
  };

  try {
    const url = dataExport.signature_checker;
    const { data: buffer } = url
      ? await axios.get(url, { responseType: "arraybuffer" })
      : { data: null };

    if (buffer) {
      const imageId = workbook.addImage({ buffer, extension: "png" });
      worksheet.addImage(imageId, {
        tl: { col: 16.5, row: 5 },
        br: { col: 18, row: 6 },
      });
    }
  } catch {}

  try {
    const url = dataExport.signature_approver;
    const { data: buffer } = url
      ? await axios.get(url, { responseType: "arraybuffer" })
      : { data: null };

    if (buffer) {
      const imgId = workbook.addImage({ buffer, extension: "png" });
      worksheet.addImage(imgId, {
        tl: { col: 16.5, row: 7 },
        br: { col: 18, row: 8 },
      });
    }
  } catch {}

  worksheet.getCell("P1").alignment = {
    vertical: "center",
    horizontal: "right",
  };
  worksheet.getCell(
    "N3"
  ).value = `Po / Order No : ${dataExport.purchaseNumber}     `;
  worksheet.getCell("A1").style = {
    font: {
      name: "Times New Roman",
      size: "18",
      bold: true,
    },
  };
  worksheet.getCell("Q1").style = {
    font: {
      name: "Times New Roman",
      size: "9",
      bold: true,
    },
  };
  worksheet.getCell("N3").style = {
    font: {
      name: "Times New Roman",
      size: "14",
      bold: false,
    },
  };
  worksheet.getCell("Q1").alignment = {
    vertical: "bottom",
    horizontal: "left",
  };
  worksheet.getCell("A1").alignment = {
    vertical: "middle",
    horizontal: "center",
  };
  worksheet.getCell("N3").alignment = {
    vertical: "bottom",
    horizontal: "center",
  };
  ///////////////////////////////////////////////Drawline Header////////////////////
  for (let col = 2; col <= 18; col++) {
    const cell = worksheet.getCell(`${String.fromCharCode(64 + col)}3`);
    cell.border = {
      bottom: { style: "thin" },
    };
  }
  //////////////////////////////////////////DRAWLINE BODY//////////////////////////////
  for (let col = 4; col <= 17; col++) {
    const cell = worksheet.getCell(`S${col}`);
    cell.border = {
      left: { style: "thin" },
    };
  }
  for (let col = 4; col <= 17; col++) {
    const cell = worksheet.getCell(`H${col}`);
    cell.border = {
      right: { style: "thin" },
    };
  }
  for (let col = 4; col <= 17; col++) {
    const cell = worksheet.getCell(`O${col}`);
    cell.border = {
      right: { style: "thin" },
    };
  }

  worksheet.getCell("A4").border = {
    left: { style: "thin" },
    top: { style: "thin" },
  };
  for (let col = 5; col <= 17; col++) {
    if (col == 17) {
      const cell = worksheet.getCell(`A17`);
      cell.border = {
        left: { style: "thin" },
        // bottom: { style: "thin" },
      };
    } else {
      const cell = worksheet.getCell(`A${col}`);
      cell.border = {
        left: { style: "thin" },
      };
    }
  }
  // for (let col = 2; col <= 17; col++) {
  //   if (col == 8 || col == 15) {
  //     const cell = worksheet.getCell(`${String.fromCharCode(64 + col)}17`);
  //     cell.border = {
  //       bottom: { style: "thin" },
  //       right: { style: "thin" },
  //     };
  //   } else {
  //     const cell = worksheet.getCell(`${String.fromCharCode(64 + col)}17`);
  //     cell.border = {
  //       bottom: { style: "thin" },
  //     };
  //   }
  // }
  // worksheet.getCell("R17").border = {
  //   bottom: { style: "thin" },
  // }
  //////////////////////////////////////////
  ///////////////////////////////////////////////////DETERMINE ROW HEIGHT //////////////////////////////////////
  for (let i = 4; i <= 17; i++) {
    worksheet.getRow(i).height = 30;
  }
  for (let i = 18; i <= 19; i++) {
    worksheet.getRow(i).height = 36;
  }
  for (let i = 20; i <= 31; i++) {
    worksheet.getRow(i).height = 36;
  }
  worksheet.getColumn(1).width = 19;
  worksheet.getColumn(2).width = 29;
  worksheet.getColumn(3).width = 36;
  worksheet.getColumn(4).width = 8;
  worksheet.getColumn(5).width = 28;

  ///////////////////////////////////////////////////////CONTENT HEADER////////////////////////////////////////
  worksheet.mergeCells("I4:J4");
  worksheet.mergeCells("K4:N4");
  // worksheet.getCell("K4").value = "D03B";
  worksheet.getCell("K4").style = {
    font: {
      name: "Times New Roman",
      size: "13",
      bold: false,
    },
  };
  worksheet.getCell("K4").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("L4").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("I4").value = "Model:";
  worksheet.getCell("I4").style = {
    font: {
      name: "Times New Roman",
      size: "14",
      bold: false,
    },
  };



  worksheet.mergeCells("I6:J6");
  worksheet.mergeCells("K6:N6");
  worksheet.getCell("K6").value = `${dataExport.partCode}`;
  worksheet.getCell("K6").style = {
    font: {
      name: "Times New Roman",
      size: "13",
      bold: false,
    },
  };
  worksheet.getCell("K6").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("L6").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("I6").value = "Part No:";
  worksheet.getCell("I6").style = {
    font: {
      name: "Times New Roman",
      size: "14",
      bold: false,
    },
  };

  worksheet.mergeCells("I8:J8");
  worksheet.mergeCells("K8:N8");
  worksheet.getCell("K8").value = `${dataExport.partName}`;
  worksheet.getCell("K8").style = {
    font: {
      name: "Times New Roman",
      size: "13",
      bold: false,
    },
  };
  worksheet.getCell("K8").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("L8").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("I8").value = "Part Name:";
  worksheet.getCell("I8").style = {
    font: {
      name: "Times New Roman",
      size: "14",
      bold: false,
    },
  };

  worksheet.mergeCells("I10:J10");
  worksheet.mergeCells("K10:N10");
  // worksheet.getCell("K10").value = "TOYOTA";
  worksheet.getCell("K10").style = {
    font: {
      name: "Times New Roman",
      size: "13",
      bold: false,
    },
  };
  worksheet.getCell("K10").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("L10").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("I10").value = "Customer :";
  worksheet.getCell("I10").style = {
    font: {
      name: "Times New Roman",
      size: "14",
      bold: false,
    },
  };

  worksheet.mergeCells("I12:J12");
  worksheet.mergeCells("K12:N12");

  // worksheet.getCell("K12").value = "JRP";

  worksheet.getCell("K12").style = {
    font: {
      name: "Times New Roman",
      size: "13",
      bold: false,
    },
  };
  worksheet.getCell("K12").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("L12").border = {
    bottom: { style: "thin" },
  };

  worksheet.getCell("I12").value = "Supplier :";
  worksheet.getCell("I12").style = {
    font: {
      name: "Times New Roman",
      size: "14",
      bold: false,
    },
  };

  worksheet.mergeCells("I14:J14");
  worksheet.mergeCells("K14:N14");

  worksheet.getCell("I14").value = "Q'ty :";
  worksheet.getCell("K14").style = {
    font: {
      name: "Times New Roman",
      size: "13",
      bold: false,
    },
  };
  worksheet.getCell("K14").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("L14").border = {
    bottom: { style: "thin" },
  };
  worksheet.getCell("I14").style = {
    font: {
      name: "Times New Roman",
      size: "14",
      bold: false,
    },
  };

  // Headings
worksheet.getCell("D17").value = "REV.";
worksheet.mergeCells("E17:G17");
worksheet.getCell("E17").value = "DESCRIPTION";
worksheet.getCell("H17").value = "EFFECTIVE\nDATE"; // multi-line in 1 cell

["D17", "E17", "H17"].forEach((cell) => {
  worksheet.getCell(cell).alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true,
  };
  worksheet.getCell(cell).font = {
    name: "Times New Roman",
    size: 8, // smaller title
    bold: true,
  };
  worksheet.getCell(cell).border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
});

const revisionRecord = dataExport.revisionRecord || [];

const total = revisionRecord.length;
const startRowIndex = 14 + (3 - total); 

revisionRecord.forEach((rev, index) => {
  const rowIndex = startRowIndex + index;

  worksheet.getCell(`D${rowIndex}`).value = rev.rev;
  worksheet.mergeCells(`E${rowIndex}:G${rowIndex}`);
  worksheet.getCell(`E${rowIndex}`).value = rev.description;
  worksheet.getCell(`H${rowIndex}`).value = rev.date;

  ["D", "E", "H"].forEach((col) => {
    const cell = worksheet.getCell(`${col}${rowIndex}`);
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };
    cell.font = { name: "Times New Roman", size: 10 };
    cell.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  });
});







  worksheet.mergeCells("I16:J16");
  // worksheet.getCell("I16").value = "Sampling Q'ty";

  worksheet.getCell("I16").dataValidation = {
    type: "list",
    allowBlank: true,
    formulae: ['"Sampling,AQL"'],
  };

  worksheet.getCell("I16").value = "Sampling";

  worksheet.getCell("I16").font = {
    name: "Times New Roman",
    size: "11",
    bold: false,
  };
  worksheet.getCell("I16").alignment = {
    vertical: "top",
  };

  worksheet.getCell("L16").value = "Pcs.";
  worksheet.getCell("L16").alignment = {
    vertical: "top",
  };

  worksheet.getCell("M16").value = "Q'ty";
  worksheet.getCell("M16").alignment = {
    vertical: "top",
  };

  worksheet.getCell("O16").value = "Pcs.";
  worksheet.getCell("O16").alignment = {
    vertical: "top",
  };

  worksheet.mergeCells("Q4:R4");
  worksheet.getCell("Q4").value = dataExport.publishedAt;
  worksheet.getCell("P4").value = "Date:";
  worksheet.getCell("P4").font = {
    name: "Times New Roman",
    size: "13",
    bold: false,
  };

  worksheet.getCell("P6").value = "Check by:";
  worksheet.getCell("P6").font = {
    name: "Times New Roman",
    size: "13",
    bold: false,
  };

  worksheet.getCell("P8").value = "Approve by:";
  worksheet.getCell("P8").font = {
    name: "Times New Roman",
    size: "13",
    bold: false,
  };

  worksheet.mergeCells("P12:R12");
  worksheet.getCell("P12").value = "INSPECTION RESULT";
  worksheet.getCell("P12").alignment = {
    vertical: "middle",
    horizontal: "center",
  };
  worksheet.getCell("P12").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };

  worksheet.getCell("P12").border = {
    bottom: { style: "thin" },
    top: { style: "thin" },
  };

  worksheet.mergeCells("P14:R14");
  worksheet.getCell("P14").value = "☐ Accept";
  worksheet.getCell("P14").alignment = {
    vertical: "middle",
    horizontal: "center",
  };
  worksheet.getCell("P14").font = {
    name: "Times New Roman",
    size: "14",
    bold: true,
  };
  worksheet.mergeCells("P16:R16");
  worksheet.getCell("P16").value = "☐ Reject";
  worksheet.getCell("P16").alignment = {
    vertical: "middle",
    horizontal: "center",
  };
  worksheet.getCell("P16").font = {
    name: "Times New Roman",
    size: "14",
    bold: true,
  };
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////CONTENT BODY///////////////////////////////////////////////////
  ///////TOPIC////////
  worksheet.mergeCells("A18:A19");
  worksheet.getCell("A18").value = "Item";
  worksheet.getCell("A18").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
  worksheet.getCell("A18").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };
  worksheet.getCell("A18").alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  worksheet.mergeCells("B18:B19");
  worksheet.getCell("B18").value = "Standard";
  worksheet.getCell("B18").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
  worksheet.getCell("B18").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };
  worksheet.getCell("B18").alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  worksheet.mergeCells("C18:D19");
  worksheet.getCell("C18").value = "Inspection Tool";
  worksheet.getCell("C18").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
  worksheet.getCell("C18").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };
  worksheet.getCell("C18").alignment = {
    vertical: "middle",
    horizontal: "center",
  };
//////////////////////////////////////////
  worksheet.mergeCells("E18:E19");
  worksheet.getCell("E18").value = "Rank";
  worksheet.getCell("E18").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
  worksheet.getCell("E18").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };
  worksheet.getCell("E18").alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  for (let i = 20; i < 20 + dataExport.dataquestion.length; i++) {
    const cell = worksheet.getCell(`E${i}`);
    cell.value = `${dataExport.rank || "N/A"}`;
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
    };
  }

  worksheet.mergeCells("F18:O18");
  worksheet.getCell("F18").value = "Sample No.";
  worksheet.getCell("F18").border = {
    top: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
  worksheet.getCell("F18").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };
  worksheet.getCell("F18").alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  let i = 0;
  for (let col = 6; col <= 15; col++) {
    const cell = worksheet.getCell(`${String.fromCharCode(64 + col)}19`);
    cell.value = `${i + 1}`;
    cell.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    i++;
  }

  worksheet.mergeCells("P18:P19");
  worksheet.getCell("P18").value = "Result";
  worksheet.getCell("P18").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
  worksheet.getCell("P18").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };
  worksheet.getCell("P18").alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  worksheet.mergeCells("Q18:R19");
  worksheet.getCell("Q18").value = "Remark";
  worksheet.getCell("Q18").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
  worksheet.getCell("Q18").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };
  worksheet.getCell("Q18").alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`A${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }

  let rowColumn = 20;
  for (let i = 0; i < dataExport.dataquestion.length; i++) {
    worksheet.getCell(`C${rowColumn}}`).value =
      dataExport.dataquestion[i].inspectionTool;
    rowColumn++;
  }

  //dataExport.dataquestion[i]?.checkPoint
  for (let i = 0; i < dataExport.dataquestion.length; i++) {
    const countName = dataExport.dataquestion.reduce((acc, item) => {
      acc[item.sub_category] = (acc[item.sub_category] || 0) + 1;
      return acc;
    }, {});
    // console.log(countName);
    const keys = Object.keys(countName);
    // console.log(countName[keys[0]]);

    const idenifyLine = countName[keys[0]];

    if (i == 0) {
      const cell = worksheet.getCell(`A${20 + i}`);
      cell.value = `${dataExport.dataquestion[i]?.sub_category}`;
      cell.font = {
        name: "AngsanaUPC",
        size: 12,
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    }
    if (i == idenifyLine) {
      const cell = worksheet.getCell(`A${20 + idenifyLine}`);
      cell.value = `${dataExport.dataquestion[i]?.sub_category}`;
      cell.font = {
        name: "AngsanaUPC",
        size: 12,
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    }

    worksheet.getCell(`B${20 + i}`).value = `${dataExport.dataquestion[i]?.checkPoint}`;
  }
  for (let i = 0; i < dataExport.dataquestion.length; i++) {
    for (let j = 0; j <= dataExport.dataquestion[i].actual1.length; j++) {
      const columnLetter = String.fromCharCode(70 + j); // 70 is the char code for 'F'
      const cell = worksheet.getCell(`${columnLetter}${20 + i}`);

      // Add data or "OK" to the cell
      cell.value =
        j < dataExport.dataquestion[i].actual1.length
          ? `${dataExport.dataquestion[i].actual1[j]}`
          : "OK";

      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    }
  }

  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`B${i}`).font = {
      name: "AngsanaUPC",
      size: 12,
    };
  }

  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`B${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }

  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`C${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`E${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`F${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`G${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`H${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`I${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`J${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`K${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`L${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`M${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`N${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`O${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }

  for (let i = 20; i <= 29; i++) {
    worksheet.getCell(`P${i}`).border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  }
  worksheet.getCell("A30").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
  worksheet.getCell("Q20").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  worksheet.getCell("C30").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  worksheet.getCell("F30").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  worksheet.getCell("K30").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };
  worksheet.getCell("P30").border = {
    top: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
    right: { style: "thin" },
  };

  worksheet.mergeCells("Q20:R31");
  worksheet.mergeCells("ฺA30:B31");
  worksheet.mergeCells("ฺC30:E31");
  worksheet.mergeCells("ฺF30:J31");
  worksheet.mergeCells("ฺK30:O31");
  worksheet.mergeCells("ฺP30:P31");

  for (let i = 20; i <= 29; i++) {
    worksheet.mergeCells(`C${i}:D${i}`);
  }

  worksheet.getCell("A30").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };

  worksheet.getCell("C30").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };

  worksheet.getCell("F30").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };

  worksheet.getCell("K30").font = {
    name: "Times New Roman",
    size: "13",
    bold: true,
  };

  worksheet.getCell("A30").value = "Issued Date";
  worksheet.getCell("C30").value = "Prepared By";
  worksheet.getCell("F30").value = "Checked by";
  worksheet.getCell("K30").value = "Approved by";

  worksheet.getCell("A30").alignment = {
    horizontal: "center",
    vertical: "top",
  };

  worksheet.getCell("C30").alignment = {
    horizontal: "center",
    vertical: "top",
  };

  worksheet.getCell("F30").alignment = {
    horizontal: "center",
    vertical: "top",
  };

  worksheet.getCell("K30").alignment = {
    horizontal: "center",
    vertical: "top",
  };

  worksheet.getCell("K4").value = `${dataExport.model}`;
  worksheet.getCell("K10").value = `${dataExport.customer}`;
  worksheet.getCell("K12").value = `${dataExport.supplier}`;

  worksheet.getCell("Q20").value = `VERNIER NO : ${dataExport.vernierNo}`;
  worksheet.getCell("Q20").alignment = {
    horizontal: "center",
    vertical: "middle",
    wrapText: true,
  };

  // console.log("Signature checker URL:", dataExport.signature_checker);
  // console.log("Signature approver URL:", dataExport.signature_approver);

  if (dataExport.signature_checker) {
    const image_signature_checker = await axios.get(
      dataExport.signature_checker,
      {
        responseType: `arraybuffer`,
      }
    );
    const signature_checker = workbook.addImage({
      buffer: image_signature_checker.data,
      extension: `png`,
    });
    // worksheet.addImage(signature_checker, `G31:I31`);
    worksheet.addImage(signature_checker, {
      tl: { col: 6.5, row: 30 },
      br: { col: 9, row: 31 },
      // ext: { width: 1024, height: 1024 },
    });

    worksheet.addImage(signature_checker, {
      tl: { col: 16, row: 5 }, 
      br: { col: 18, row: 6 },   
    });
    
  }

  if (dataExport.signature_approver) {
    const image_signature_approver = await axios.get(
      dataExport.signature_approver,
      {
        responseType: `arraybuffer`,
      }
    );
    const signature_approver = workbook.addImage({
      buffer: image_signature_approver.data,
      extension: `png`,
    });
    // worksheet.addImage(signature_checker, `G31:I31`);
    worksheet.addImage(signature_approver, {
      tl: { col: 11.5, row: 30 },
      br: { col: 14, row: 31 },
      // ext: { width: 1024, height: 1024 },
    });

    worksheet.addImage(signature_approver, {
      tl: { col: 16, row: 7 }, 
      br: { col: 18, row: 8 },   
    });
  }

  await workbook.xlsx.writeBuffer().then((res) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([res], { type: fileType });
    saveAs(
      blob,
      `Inspecction_checksheet_${dataExport.partName}_${day}_${month}_${year}` +
        fileExtension
    );
  });
}
